<!--赖传峰-->
<!--2021/12/13-->
<!--头像加载器-->
<template>
  <div
    :class="className"
    data-allow-mismatch
    class="avatar-wrapper"
  >
    <img
      v-if="imgLoaded"
      :alt="props.alt"
      :src="props.src"
      class="avatar"
    >
    <div
      v-else
      class="placeholder"
    />
  </div>
</template>

<script
  lang="ts"
  setup
>
import {
  computed,
  ref,
  watch,
} from '#imports'
import {
  AvatarSize,
  Shape,
} from './avatar.script'

interface PropsTypes {
  size?: AvatarSize;
  premium?: boolean;
  src?: string;
  shape?: Shape;
  alt?: string;
}

const props = withDefaults(defineProps<PropsTypes>(), {
  size: AvatarSize.NORMAL,
  premium: false,
  src: undefined,
  shape: Shape.CIRCLE,
  alt: '',
})

const imgLoaded = ref(false)

watch(() => props.src, val => {
  if (!val) return
  const img = new Image()
  img.src = val
  img.onload = () => { imgLoaded.value = true }
})

const className = computed<string>(() => {
  const premiumClassName = props.premium ? 'is-premium' : 'not-premium'
  return `${premiumClassName} ${props.size} ${props.shape}`
})
</script>

<style
  lang="less"
  scoped
>
.avatar-wrapper {
  overflow: hidden;
}

.circle {
  border-radius: 50%;
}

.shape {
  border-radius: 4px;
}

.placeholder {
  width: 100%;
  height: 100%;
}

.is-premium {
  border: 2px solid #f4ead2;

  .placeholder {
    background: url('@/assets/images/drive-layout/premium-default-avatar.png') #d3be8f var(--no-repeat-center);
  }
}

.not-premium {
  border: 1px solid #d0dae0;

  .placeholder {
    background: url('@/assets/images/drive-layout/default-avatar.png') #7793a3 var(--no-repeat-center);
  }
}

.small {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;

  .placeholder {
    background-size: 20px;
  }
}

.normal {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;

  .placeholder {
    background-size: 25px;
  }
}

.large {
  width: 48px;
  height: 48px;
  flex: 0 0 48px;

  .placeholder {
    background-size: 28px;
  }
}

.avatar {
  width: 100%;
  height: 100%;
}
</style>
